import { Icon, Icons, Tooltip } from '@silverfort/sf-components';
import { Application } from '../../../../types/Application';
import { FC } from 'react';

interface ApplicationNameCellProps {
    app: Application;
    onClick: (appId: string) => void;
}

export const ApplicationNameCell: FC<ApplicationNameCellProps> = ({ app, onClick }) => {
    const isFromApi = app.ref_type === 'ServiceNow';

    return (
        <div className="max-w-80 flex flex-row justify-between cursor-pointer" onClick={() => onClick(app.app_id)}>
            <Tooltip onlyOnOverflow title={app.name}>
                <span>{app.name}</span>
            </Tooltip>

            <div className="flex gap-2">
                {isFromApi && (
                    <Tooltip title={'Imported from API'}>
                        <Icon icon={Icons.Integration} size={20} />
                    </Tooltip>
                )}
            </div>
        </div>
    );
};
